import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import putData from "../services/putData";

const handleFetchBookings = async ({ site }: any) => {
  const uri = `v1/bookings?site=${site}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateBooking = async (data: any) => {
  const uri = `v1/bookings`;
  const response = postData({ data, uri });
  return response;
};

const handleConfirmBooking = async ({ data, _id }: any) => {
  const uri = `v1/bookings/${_id}/confirm`;
  const response = postData({ data, uri });
  return response;
};


const handleScheduleBooking = async ({ data, _id }: any) => {
  const uri = `v1/bookings/${_id}/reschedule`;
  const response = postData({ data, uri });
  return response;
};

const handleFulfillBooking = async ({ data, _id }: any) => {
  const uri = `v1/bookings/${_id}/fulfill`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateBooking = async ({ data, _id }: any) => {
  const uri = `v1/bookings/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleExportBookings = async ({ data, _id }: any) => {
  const uri = `v1/bookings/export/all`;
  const response = putData({ data, uri });
  return response;
};

const handleDeleteBooking = async ({ _id }: any) => {
  const uri = `v1/bookings/${_id}`;
  const response = deleteData({ uri });
  return response;
};

const handleCountBookings = async ({
  site,
  isConfirmed,
  isFulfilled,
}: any) => {
  const uri = `v1/bookings/count/all?site=${site}&isConfirmed=${isConfirmed}&isFulfilled=${isFulfilled}`;
  const response = fetchData({ uri });
  return response;
};

export {
  handleFetchBookings,
  handleCreateBooking,
  handleUpdateBooking,
  handleDeleteBooking,
  handleCountBookings,
  handleConfirmBooking,
  handleScheduleBooking,
  handleFulfillBooking,
  handleExportBookings,
};
